import { ChangeDetectorRef, Component, NgZone, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute, Params, ParamMap, Scroll, NavigationStart, NavigationEnd } from '@angular/router';
import { DecimalPipe, ViewportScroller } from '@angular/common';
import { Globals } from '../shared/globals';
import { Title } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { Subscription, combineLatest, map, mergeMap, combineLatestWith, switchMap, concatMap, filter, take, forkJoin } from 'rxjs';
import { ProgrammeService } from './programme.service';
import { TextService } from '../shared/text.service';
import { ScrollPositionService } from '../shared/scroll-position-service';


//const scrollPositions = new Map<string, number>();
const scrollPositions = new Map<string, number>();

@Component({
  selector: 'app-programme',
  templateUrl: './programme.component.html',
  styleUrls: ['./programme.component.css']
  //,encapsulation: ViewEncapsulation.None
})
export class ProgrammeComponent implements OnInit {

  id: any;
  programmeId: any;
  period: any;
  showInitialized = false;
  programme: any;
  courseUnit: any;
  courseUnitRealization: any[] = [];
  //learningPaths: any;
  accomplishmentPlans: any;
  periodCount: any;
  isPeriodCountLoaded = true;
  currentPeriodStartYear = environment.currentPeriodStartYear;
  profileName: any = environment.profileName;

  selectedPlan: any;
  //learningPaths: any[] = [];
  selectedPath: any;

  isCourseUnitLoaded = false;
  isCourseUnitRealizationsLoaded = false;
  accomplishmentPlan = 1;
  isAccomplishmentPlanLoaded = true;
  selection = 1;
  selectedView: any;
  selectedViewValue: any; //tämä sama kuin käyttöliittymän arvo
  selectedPlanIndex: any = 0;// tämä sama kuin valitun ajoitussuunnitelman indeksi valikossa
  programmeDescription: any;
  //programmeDescription: any[] = [];
  isLoaded = false;
  selectedSchoolYear = 0;
  //toggle = true;

  errorMessage: string = '';
  showSchoolYearPlan: any;
  showSemesterPlan: any;
  showPeriodPlan: any;
  showDegreeDescription: any;
  showAccomplishmentPlan: any;
  // showLearningPaths: LocalizedString;
  academicYear: any;
  academicYear2: any;
  academicYear3: any;
  academicYear4: any;
  academicYear5: any;
  academicYear6: any;
  degreeDescription: any;
  close: any;
  fetchingData: any;
  accomplishmentPlanNotFound: any;
  creditPoints: any;

  langChangedSubscription: any;
  langSelection: any;
  programmeSubscription: any;
  programmeDescriptionSubscription: any;
  urlSubscription: any;
  
 
  private subscription: Subscription = new Subscription();
//private scrollPositions = new Map<string, number>();
  private previousUrl: string | null = null; // start as null
  

  constructor(
    //private courseService: CourseService,
    private programmeService: ProgrammeService,
    public globals: Globals,
    private route: ActivatedRoute,
    private router: Router,
    private textService: TextService,
    private titleService: Title,
    private zone: NgZone,
    private scrollService: ScrollPositionService,
    private cdr: ChangeDetectorRef
    
  ) { 
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const container = document.querySelector('mat-sidenav-content');  
        this.scrollService.set(this.selectedSchoolYear, this.selectedViewValue, this.selectedPlan?.accomplishmentPlanId, this.selectedPlanIndex, this.router.url, container ? container.scrollTop : 0);
      }
    });
  }
 
  //ngAfterViewChecked() {
    /*setTimeout(() => {
      const container = document.querySelector('mat-sidenav-content');
      if (container) container.scrollTop = this.scrollService.get(this.router.url);
    }, 0);*/
   /* if (!this.hasRestored) {
      // restore asynchronously so Angular’s rendering cycle is truly complete
      setTimeout(() => {
        const container = document.querySelector('mat-sidenav-content'); // Or '.content'
        if (container) {
          container.scrollTop = this.scrollService.get(this.router.url);
          // For debug:
          // console.log("Restored container.scrollTop", container.scrollTop, "for", this.router.url);
        }
        this.hasRestored = true; // prevent looping/extra restores
      }, 450);
    }
  }*/

  ngOnInit(): void {

    //tämä tärkeä, jotta kieli alustuu urlin perusteella
    this.subscription.add(this.globals.setLangFromRoute(this.route));
    
    // haetaan tekstejä
    this.subscription.add(
      forkJoin({
        showSchoolYearPlan:   this.textService.getText('accomplishment.plan.show.school.year'),
        showSemesterPlan:     this.textService.getText('accomplishment.plan.show.semester'),
        showPeriodPlan:       this.textService.getText('accomplishment.plan.show.period'),
        academicYear:         this.textService.getText('accomplishment.plan.school.year.1'),
        academicYear2:        this.textService.getText('accomplishment.plan.school.year.2'),
        academicYear3:        this.textService.getText('accomplishment.plan.school.year.3'),
        academicYear4:        this.textService.getText('accomplishment.plan.school.year.4'),
        academicYear5:        this.textService.getText('accomplishment.plan.school.year.5'),
        academicYear6:        this.textService.getText('accomplishment.plan.school.year.6'),
        showDegreeDescription:this.textService.getText('accomplishment.plan.show.degree.description'),
        showAccomplishmentPlan:this.textService.getText('accomplishment.plan.show.structure'),
        degreeDescription:    this.textService.getText('degree.description'),
        close:                this.textService.getText('close'),
        fetchingData:         this.textService.getText('fetching.data'),
        accomplishmentPlanNotFound: this.textService.getText('accomplishment.plan.not.found'),
        creditPoints:         this.textService.getText('credit.points')
      }).subscribe({
        next: result => {
          this.showSchoolYearPlan      = result.showSchoolYearPlan;
          this.showSemesterPlan        = result.showSemesterPlan;
          this.showPeriodPlan          = result.showPeriodPlan;
          this.academicYear            = result.academicYear;
          this.academicYear2           = result.academicYear2;
          this.academicYear3           = result.academicYear3;
          this.academicYear4           = result.academicYear4;
          this.academicYear5           = result.academicYear5;
          this.academicYear6           = result.academicYear6;
          this.showDegreeDescription   = result.showDegreeDescription;
          this.showAccomplishmentPlan  = result.showAccomplishmentPlan;
          this.degreeDescription       = result.degreeDescription;
          this.close                   = result.close;
          this.fetchingData            = result.fetchingData;
          this.accomplishmentPlanNotFound = result.accomplishmentPlanNotFound;
          this.creditPoints            = result.creditPoints;
        },
        error: error => {
          this.errorMessage = error;
        }
      })
    );

    this.subscription.add(combineLatest([this.route.paramMap, this.route.queryParamMap]).pipe(
      map(params => ({
        programmeId: params[0].get('id'), 
        period: params[1].get('period')
      })),
      // haetaan ajoitussuunnitelma
      mergeMap(params => {
        this.programmeId = params.programmeId;
        this.period = params.period;
        this.setCurrentUrl();
        //tämä halutaan suorittaa, jos tullaan back-buttonilla
        const accomplishmentPlanId = this.scrollService.get(this.router.url)?.accomplishmentPlanId;
        if(accomplishmentPlanId !== undefined) {
          return this.programmeService.getAccomplishmentPlan(accomplishmentPlanId);  
        } else {
          return this.programmeService.getProgrammeWithLearningUnit(this.programmeId);
        }
      }),
      //haetaan kuvaus
      mergeMap(programme => {
        this.programme = programme;
        if (this.programme.length > 0) {
          this.setTitle();
        }
        return this.programmeService.getProgrammeDescription(this.programmeId);
      }),
      mergeMap(description => {
        this.programmeDescription = description;
        return this.programmeService.getAccomplishmentPlanList(this.programmeId);
      })
      ).subscribe(
        accomplishmentPlans => {
          this.accomplishmentPlans = accomplishmentPlans;

          //oletuksena näytetään listan ensimmäinen
          //const selectedPlan = this.scrollService.get(this.router.url)?.selectedPlan;
          const selectedPlanIndex = this.scrollService.get(this.router.url)?.selectedPlanIndex;
          //console.log(selectedPlanIndex);
          if(selectedPlanIndex === undefined) {
            this.selectedPlan = this.accomplishmentPlans[0];
            this.selectedPlanIndex = 0;
          } else {
            //ajoitussuunnitelman valinta
            this.selectedPlan = this.accomplishmentPlans[selectedPlanIndex];
            //index on 1,2,3,... 
            this.selectedPlanIndex = selectedPlanIndex;
          }
          //Tätä ei ehkä voida ajaa, jos halutaan scrollata
          //this.selectAccomplishmentPlan(this.selectedPlan, this.selectedPlanIndex);
          
          this.isLoaded = true;

          //täällä asetellaan scroll position paikoilleen 
          this.cdr.detectChanges(); // Ensure view/children update

          setTimeout(() => {
            const container = document.querySelector('mat-sidenav-content');
            if (container) {
              container.scrollTop = this.scrollService.get(this.router.url)?.pos;
              //this.setSelection('period');
              //const plan = this.scrollService.get(this.router.url)?.selectedPlan;
              /*if(plan) {
                this.selectAccomplishmentPlan(plan);
              }*/
              const view = this.scrollService.get(this.router.url)?.selectedView;
              if(view === 'period') {
                this.setAccomplishmentPlanYear(this.scrollService.get(this.router.url)?.selectedYear);

              } else {
                this.setSelection(view);
              }
              this.selectedViewValue = view;
              //this.selectAccomplishmentPlan(this.selectedPlan, this.selectedPlanIndex);
              //this.selectAccomplishmentPlan(this.scrollService.get(this.router.url)?.selectedPlan, 2);
              //console.log('plan: ' + selectedPlan + 'and planindex: ' + this.selectedPlanIndex);
              //if(selectedPlan !== undefined) {console.log('testi')}
                //this.selectAccomplishmentPlan(this.scrollService.get(this.router.url)?.selectedPlan);
              //console.log('test ' + this.scrollService.get(this.router.url)?.selectedView);

            }
          }, 0); // Usually just 0ms works!
        

          (error: any) => this.errorMessage = <any>error;
          
        }
        
        
      ));
        
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onLangChanged(lang: string): void {
    //console.log('lang has changed to ' + lang);
    this.titleService.setTitle(this.globals.getLocalizedValue(this.programme[0].name) + environment.titleExtension);
    //this.toggle = true;
  }

  /*toggleThis() {
    if (this.toggle) {
      this.toggle = false;
    } else {
      this.toggle = true;
    }
  }*/
 getPeriodNumber(i: number): number {
    const totalPeriods = this.programme[0].accomplishmentPlanPeriodList.length;
    const periodsPerYear = Math.round(totalPeriods / this.programme[0].duration);
    const offset = this.programme[0].startSemester * Math.floor(periodsPerYear / 2);
    const firstYearPeriods = periodsPerYear - offset;
    
    // Calculate global index based on selected year
    let globalIndex: number;
    if (this.selectedSchoolYear === 1) {
        globalIndex = i;
    } else {
        globalIndex = firstYearPeriods + (this.selectedSchoolYear - 2) * periodsPerYear + i;
    }
    
    return ((globalIndex + offset) % periodsPerYear) + 1;
}

  filterAccomplishmentPlanSemesterList(accomplishmentPlanSemesterList: any) {
    return accomplishmentPlanSemesterList.slice(this.selectedSchoolYear, accomplishmentPlanSemesterList.length);
  }

  filterAccomplishmentPlanList(accomplishmentPlanList: any) {
      return accomplishmentPlanList.slice(this.selectedSchoolYear, accomplishmentPlanList.length);
  }

  /*filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any) {
    return accomplishmentPlanPeriodList.slice(this.sum(this.periodCount.slice(0, this.selectedSchoolYear)), this.sum(this.periodCount.slice(0, this.selectedSchoolYear+1)));
  }*/

  /*filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any, accomplishmentPlanYearList: any) {
    let periodCount = Math.ceil(accomplishmentPlanPeriodList.length / accomplishmentPlanYearList.length);
    return accomplishmentPlanPeriodList.slice((this.selectedSchoolYear * periodCount - periodCount), this.selectedSchoolYear * periodCount);
  }*/
  filterAccomplishmentPlanPeriodList(accomplishmentPlanPeriodList: any, accomplishmentPlanYearList: any) {
      const totalPeriods = accomplishmentPlanPeriodList.length;
      const periodsPerYear = Math.round(totalPeriods / this.programme[0].duration);
      const offset = this.programme[0].startSemester * Math.floor(periodsPerYear / 2);
      const firstYearPeriods = periodsPerYear - offset;

      let start: number;
      let end: number;

      if (this.selectedSchoolYear === 1) {
          start = 0;
          end = firstYearPeriods;
      } else {
          start = firstYearPeriods + (this.selectedSchoolYear - 2) * periodsPerYear;
          end = start + periodsPerYear;
      }

      return accomplishmentPlanPeriodList.slice(start, end);
  }
 
  sum(list: any): any {
    const sum = list.reduce((partialSum: any, a: any) => partialSum + a, 0);
    //console.log("summa: " +  sum);
    return sum;
  }


    setAccomplishmentPlanYear(year: any) {
      this.selectedSchoolYear = year;
      this.selection = 3;
    }

    selectLearningPath(path: any) {
      this.selection = 4;
      this.selectedPath = path;
    }

  // pudotusvalikon valinta
  setSelection(view: any) {
    //console.log('laukaistiin käsittelijä: ' + view)
    //this.selectedView = 1;
      if ('schoolyear' === view) {
        this.selectedViewValue = view;
        this.selection = 1;
        this.selectedSchoolYear = 0;
      } else if ('semester' === view) {
        this.selectedViewValue = view;
        this.selection = 2;
        this.selectedSchoolYear = 0;
      } else if ('period' === view) {
        this.selectedViewValue = view;
        this.selection = 3;
      } /*else if ('learningpath' === view) {
        console.log('miksi tämä alustuu')
        this.selection = 4;
      }*/
      //this.selectedSchoolYear = 1;
  }

  getSelection(selected: any) {
    if (selected === 1) {
      return this.showSchoolYearPlan;
    } else if (selected === 2) {
      return this.showSemesterPlan;
    } else if (selected === 3) {
      return this.showPeriodPlan;
    } /*else {
      return {valueFi: 'Opintopolut', valueEn: '', valueSv: ''};
    }*/
  }

  getSelectedAcademicYear(year: any) {
    if (year === 1) {
      return this.academicYear;
    } else if (year === 2) {
      return this.academicYear2;
    } else if (year === 3) {
      return this.academicYear3;
    } else if (year === 4) {
      return this.academicYear4;
    } else if (year === 5) {
      return this.academicYear5;
    } else if (year === 6) {
      return this.academicYear6;
    }
  }

  selectAccomplishmentPlan(plan: any, index: any) {
    //this.selection = 4;
    //console.log('tehtiin valinta ' + index)
    this.selectedPlanIndex = index;
    this.selectedPlan = plan;
    this.isAccomplishmentPlanLoaded = false;
    this.getAccomplishmentPlan(plan.accomplishmentPlanId);
  }

  selectAccomplishmentPlan2(event: any, plan: any, index: any) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.selectAccomplishmentPlan(plan, index);
      //this.actions3.emit({action:"dropdown", params:['close']}); 
    }
  }
  /*selectAccomplishmentPlan3(event: any, plan: any) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.selectAccomplishmentPlan(plan);
      //this.actions6.emit({action:"dropdown", params:['close']}); 
    }
  }*/


  getAccomplishmentPlan(accomplishmentPlanId: any) {
    this.subscription.add(
      //hae oikeasta paikasta
      this.programmeService.getAccomplishmentPlan(accomplishmentPlanId).subscribe(
        programme => {
          this.programme = programme;
          this.isAccomplishmentPlanLoaded = true;
      },
      error => this.errorMessage = <any>error
    ));
  }


  // precision is 10 for 10ths, 100 for 100ths, etc.
  roundUp(num: any, precision: any) {
    return Math.ceil(num * precision) / precision
  }
  

  setTitle() {
    if (this.period) {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.programme[0].name) + environment.titleExtension + ' ' + this.period);
    } else {
      this.titleService.setTitle(this.globals.getLocalizedValue(this.programme[0].name) + environment.titleExtension);
    }
  }

  setCurrentUrl() {
    // asetetaan url
    if (!this.period) {
      this.globals.currentUrl = {
        valueFi: '/fi/ohjelma/' + this.programmeId,
        valueEn: '/en/programme/' + this.programmeId,
        valueSv: '/sv/program/' + this.programmeId
      };
    } else {
      this.globals.currentUrl = {
        valueFi: '/fi/ohjelma/' + this.programmeId + '?period=' + this.period,
        valueEn: '/en/programme/' + this.programmeId + '?period=' + this.period,
        valueSv: '/sv/program/' + this.programmeId + '?period=' + this.period
      };
    }      
    this.globals.createLinkForCanonicalURL(); 
  }




}
